import { render, staticRenderFns } from "./WeeklyTable.vue?vue&type=template&id=b3e3be04&scoped=true"
import script from "./WeeklyTable.vue?vue&type=script&lang=js"
export * from "./WeeklyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e3be04",
  null
  
)

export default component.exports